<template>
  <div id="orderform">
    <h3>确认订单信息</h3>
    <!-- 课程信息 -->
    <CourseCOMP :courseInfo="courseInfo" :toPayFor_n="toPayFor_n" :sectionList="sectionList" :amountPayable="amountPayable"/>
    <!-- 章节 -->
    <ChapterCOMP v-if="$route.query.section" :courseInfo="courseInfo" :toPayFor_n="toPayFor_n" :sectionList="sectionList"/>
    <!-- 兑换券 -->
    <Exchange
            :courseInfo="courseInfo"
            :exchangeList_a="convertibility_o"
            :actualPayment="actualPayment"
            v-model:convertibilityChecked_b="convertibilityChecked_b"
            :sectionList="sectionList"/>
    <!-- 优惠券 -->
    <Discount
            :courseInfo="courseInfo"
            :couponList_a="couponList_a"
            :actualPayment="actualPayment"
            v-model:couponChecked_b="couponChecked_b"/>
    <!-- 付款方式 -->
    <div class="paymentMethod">
      <h3>选择付款方式：</h3>
      <ul>
        <li v-for="(item,index) in modeOfPment_a" @click="modeOfPment_aType_fn(index)" :key="index"
            :class="{'active':(toPayFor_n === index)}">
          <CheckOutlined/>
          <img :src="item.img" alt="">
          {{item.name}}
        </li>
      </ul>
      <div :class="`shengbei ${toPayFor_n === 2?'active':''}`">
        <div class="remainingSun">
          余额：
          <i>{{shenbeiBalance}}神贝</i>
          <span v-if="shenbeiBalance<actualPayment">神贝余额不足，请先充值</span>
        </div>
        <b class="sysRecharge" @click="recharge_fn">充值</b>
      </div>
    </div>
    <!-- 支付 -->
    <div class="price">
      <div class="amount">
        <span>应付总额：<i>{{amountPayable}}{{toPayFor_n===2?'神贝':'元'}}</i></span>
        <span v-if="couponChecked_b || convertibilityChecked_b">优惠：<i>{{discountNum}}{{toPayFor_n===2?'神贝':'元'}}</i></span>
        <b>实付款：<i>{{actualPayment?actualPayment:'0.00'}}{{toPayFor_n===2?'神贝':'元'}}</i></b>
      </div>
      <div class="payBtn" @click="payFor_fn">立即支付</div>
    </div>
  </div>
  <!-- 支付弹窗和神贝充值弹窗 -->
  <PayModal ref="payModal" v-model:data_isShow="showModal" v-model:data_toPayFor_n="toPayFor_n"
            :aliPayIframe="aliPayIframe" :userId="userId" @getUserWallet_fn="getUserWallet_fn"
            :shenbeiBalance="shenbeiBalance"/>
  <div class="aliPay" v-html="aliPayIframe.text"></div>
</template>

<script>
  import {Checkbox, message, Select, Modal} from 'ant-design-vue';
  import {CheckOutlined} from '@ant-design/icons-vue';
  import PayModal from '@c/pay/PayModal.vue';
  import Discount from '@c/pay/Discount.vue';
  import Exchange from '@c/pay/Exchange.vue';
  import {
    getCourseDetail,
    saveOrder,
    pay,
    getUserCouponsByCourse,
    getUserWallet,
    shenbeipay,
    deleteOrder,
    getUserExchangeVoucherList
  } from "@/api";
  import {getUserId,add} from "@/utils/methods";
  import CourseCOMP from "@c/pay/CourseCOMP.vue";
  import ChapterCOMP from "@c/pay/ChapterCOMP.vue";

  export default {
    name: "orderform",
    components: {
      [Checkbox.name]: Checkbox,
      [Select.name]: Select,
      [Modal.name]: Modal,
      CheckOutlined,
      PayModal,
      Discount,
      Exchange,
      CourseCOMP,
      ChapterCOMP,
    },
    data() {
      return {
        curriculumId: this.$route.query.courseId, // 课程id
        userId: getUserId(true),
        courseInfo: {},                           // 课程信息
        sectionList: [],                          // 章节列表

        couponList_a: [],                         // 优惠券列表
        couponValue: {},                          // 选中的优惠券
        couponChecked_b: false,                   // 是否使用优惠券
        couponNum: 0,                             // 优惠券金额

        convertibility_o: [],                     // 兑换券列表
        convertibilityValue: [],                  // 选中的兑换券
        convertibilityChecked_b: false,           // 是否使用兑换券
        convertibilityNum: 0,                     // 兑换券金额

        // 支付类型
        modeOfPment_a: [
          {name: '微信支付', img: require("@a/img/icon_weixin.png")},
          {name: '支付宝', img: require("@a/img/icon_zhifubao.png")},
          {name: '神贝支付', img: require("@a/img/icon_logo.png")}
        ],
        // 神贝充值
        showModal: {
          isPayQRCode_b: false,   // 支付弹窗
          isRecharge: false,      // 充值
          isDiscount: false       // 优惠卷
        },
        shenbeiBalance: 0,        // 神贝余额
        aliPayIframe: {},         // ali支付二维码

        toPayFor_n: 0,            // 支付方式 0微信 1支付宝 2神贝
        amountPayable: 0,         // 应付金额
        discountNum: 0,           // 优惠金额
        actualPayment: 0,         // 实付款

        orderNumber: '',          // 订单号
      }
    },
    provide(){
      return{
        discountNum_fn: this.discountNum_fn, // 计算优惠券金额
        getUserCouponsByCourse_fn: this.getUserCouponsByCourse_fn, // 获取优惠券列表
        convertibilityNum_fn: this.convertibilityNum_fn, // 计算兑换券金额
        getUserExchangeVoucherList_fn: this.getUserExchangeVoucherList_fn, // 获取兑换券列表
      }
    },
    methods: {
      // 获取神贝余额
      async getUserWallet_fn() {
        await getUserWallet({
          userId: this.userId
        }).then(res => {
          console.log('用户信息', res)
          if (res.data.code === 1) {
            if (res.data.data && res.data.data.shenbeiBalance) {
              this.shenbeiBalance = res.data.data.shenbeiBalance;
            } else {
              this.shenbeiBalance = 0
            }
          }
        })
      },
      // 获取课程详情
      getVideoInfo_fn() {
        this.actualPayment = 0;
        getCourseDetail({
          courseId: this.curriculumId,
          userId: this.userId,
        }).then(async (res) => {
          if (res.data.code === 1) {
            console.log('课程详情', res);
            this.courseInfo = res.data.data;
            // 应付款
            // 没有促销的课程才有优惠
            if (this.courseInfo.activity) {
              this.amountPayable = this.courseInfo.activity.discount;
              // 实付款 在未选择优惠时暂时为 应付款
              this.actualPayment = this.amountPayable;
            } else {
              // 付费主体 1：课程 2：章节
              if (this.courseInfo.payBodyType === 1) {
                this.amountPayable = this.courseInfo.money;
                // 实付款 在未选择优惠时暂时为 应付款
                this.actualPayment = this.amountPayable;
                // 是否允许使用优惠券、兑换券
                if(this.courseInfo.allowUseCoupons === 1){
                  // 优惠券列表
                  await this.getUserCouponsByCourse_fn(); // 获取优惠券
                  if(this.couponList_a.length){
                    this.couponChecked_b = true;
                  }
                }
              } else {
                // 获取章节内容
                this.getSectionList_fn();
                // 计算应付款
                this.sectionList.map(v => {
                  if (v.courseVideoDiscountPrice) {
                    this.amountPayable = add(v.courseVideoDiscountPrice , this.amountPayable);
                  } else {
                    this.amountPayable = add(v.price , this.amountPayable);
                  }
                })
                // 实付款 在未选择优惠时暂时为 应付款
                this.actualPayment = this.amountPayable;
                // 是否允许使用优惠券、兑换券
                if(this.courseInfo.allowUseCoupons === 1){
                  // 兑换券列表
                  await this.getUserExchangeVoucherList_fn();
                  // 优惠券列表
                  this.$nextTick(()=>{
                    this.getUserCouponsByCourse_fn(); // 获取优惠券
                  })
                }
              }
            }

            document.title = '支付 - ' + this.courseInfo.name;
          } else {
            message.error({
              content: '未获取到课程信息，无法支付'
            });
            this.$router.push({
              path: '/'
            });
          }
        });
      },
      // 获取章节
      getSectionList_fn() {
        // 如果点击购买全部进来
        if(this.$route.query.section){
          this.courseInfo.normalCourseVideos.map(v => {
            this.$route.query.section.split(',').map(j => {
              if (v.id === parseInt(j)) {
                this.sectionList.push(v);
              }
            })
          })
        }else{
          this.courseInfo.normalCourseVideos.map(v => {
            if(v.type === 2 && v.payStatus === 'F' && v.videoType !== 'O' && v.isTrial !== 'T'){
              this.sectionList.push(v);
            }
          })
        }
      },
      // 支付类型
      modeOfPment_aType_fn(type) {
        this.toPayFor_n = type;
      },
      // 去支付
      payFor_fn() {
        if(!this.actualPayment){
          this.toPayFor_n = 2
        }
        // 加载等待样式
        this.$store.commit('setSpinning', true)
        // 优惠券：有活动 不使用 优惠券
        let couponIdsStr = this.courseInfo.activity ? '' : this.couponChecked_b ? (this.couponValue.id ? this.couponValue.id : '') : '';
        // 兑换券：有活动 不使用 优惠券
        let convertibilityIds = [];
        this.convertibilityValue.map(v=>{
          convertibilityIds.push(v.id);
        })
        convertibilityIds = convertibilityIds.join();
        let exchangeVoucherIdsStr = this.courseInfo.activity ? '' : this.convertibilityChecked_b ? (convertibilityIds ? convertibilityIds : '') : '';
        // 要付费的章节列表
        let courseVideoIdsStr = [];
        this.sectionList.map(v=>{
          courseVideoIdsStr.push(v.id);
        })
        courseVideoIdsStr = courseVideoIdsStr.join();
        // 订单类型:神贝支付 还是 现金支付
        let orderType = this.toPayFor_n === 2 ? 'S' : 'M';
        // 支付方式
        let payType = '';
        switch (this.toPayFor_n) {
          case 0: // 微信
            payType = 'W'
            break;
          case 1: // 支付宝
            payType = 'A'
            break;
          case 2: // 神贝
            payType = 'S'
            break;
        }
        // 是否是促销 获得促销id
        let promotionId = this.courseInfo.activity ? this.courseInfo.activity.promotionId : '';
        saveOrder({
          courseId: this.curriculumId,
          userId: this.userId,
          total: this.actualPayment,  // 订单总价
          purchasePurpose: 'S',       // 购买目的 购买目的，其中S代表自用，G代表送人
          orderType: orderType,       // 订单类型
          payType: payType,           // 支付方式
          couponIdsStr: couponIdsStr, // 优惠券id，有活动 不使用 优惠券
          exchangeVoucherIdsStr: exchangeVoucherIdsStr,   // 兑换券id，有活动 不使用 兑换券
          courseVideoIdsStr: courseVideoIdsStr,           // 章节id字符串
          promotionId: promotionId,   // 活动id
          isWx: 'F',                  // 是否微信内打开
          platform: 'B',              // 平台，A代表APP，B代表PC，C代表H5
        }).then(async res => {
          console.log('是否支付', res);
          if (res.code === 1) {
            this.orderNumber = res.data.orderNumber;
            if(this.actualPayment <= 0){
              this.$store.commit('setSpinning', false)
              this.$router.push('/pages/coursePlay/coursePlay?courseId=' + this.$route.query.courseId)
              return;
            }
            // 未支付
            if (res.data.status === 'F') {
              deleteOrder({
                userId: this.userId,
                orderNumber: this.orderNumber,
              }).then(res => {
                console.log('关闭订单，重新支付', res)
                if (res.code === 1) {
                  this.payFor_fn();
                }
              })
              return;
            }
            if (this.toPayFor_n === 0 || this.toPayFor_n === 1) {
              // 微信或者支付宝
              this.pay_fn(res);
            } else if (this.toPayFor_n === 2) {
              // 神贝支付 已在saveOrder支付
              this.$refs.payModal.paySuccess_b = true

              // // 更新神贝余额
              // await this.getUserWallet_fn();
              // this.$nextTick(() => {
              //   if (parseFloat(this.shenbeiBalance) < parseFloat(this.actualPayment)) {
              //     message.error('您的神贝余额不足，请前往充值')
              //   } else {
              //     //   this.showModal.isPayQRCode_b = true;
              //     shenbeipay({
              //       orderNumber: this.orderNumber,
              //       userId: this.userId,
              //     }).then(res => {
              //       console.log('神贝支付', res)
              //       if (res.code === 1) {
              //         if (res.data.isPaySuccess === 'T') {
              //           this.$refs.payModal.paySuccess_b = true;
              //         }
              //       } else if (res.code === -1) {
              //         let that = this;
              //         Modal.confirm({
              //           title: '提示',
              //           content: res.msg,
              //           centered: true,
              //           okText: '确定',
              //           onOk() {
              //             that.$router.push('/pages/coursePlay/coursePlay?courseId=' + that.$route.query.courseId)
              //           },
              //         });
              //       }
              //     })
              //   }
              // })
            }
          } else if (res.code === -1) {
            // 已支付 或其他
            message.info(res.msg);
            if(/您的神贝余额不足!/.test(res.msg)){
              // 不跳转
            }else{
              this.$router.push('/pages/coursePlay/coursePlay?courseId=' + this.curriculumId)
            }
          } else if (res.code === -3) {
            // 费用发生更新 或其他
            message.info(res.msg);
            this.$router.push('/pages/coursePlay/coursePlay?courseId=' + this.curriculumId)
          }
          // 关闭加载动画
          this.$store.commit('setSpinning', false)
        })
      },
      // 微信或支付宝支付
      pay_fn(res) {
        this.aliPayIframe = {};
        document.querySelector('.aliPay').innerHTML = '';
        if (this.toPayFor_n === 0) {
          // 微信支付
          this.showModal.isPayQRCode_b = true;
          this.$refs.payModal.isPaySucceed(res.data.code_url, res.data.orderNumber, 'kecheng');
        } else if (this.toPayFor_n === 1) {
          this.aliPayIframe.text = res.data.orderInfoString
          // 支付宝支付
          this.aliPayIframe.origin = /action\=\"([\w|\W]+json)/.exec(res.data.orderInfoString)[1]
          this.$nextTick(() => {
            let dataVal = document.querySelector('.aliPay input[name="biz_content"]').value;
            this.aliPayIframe.src = this.aliPayIframe.origin + '&biz_content=' + encodeURIComponent(dataVal);
          })
          this.showModal.isPayQRCode_b = true;
          this.$refs.payModal.isPaySucceed('', this.orderNumber, 'kecheng');
        }
        this.$store.commit('setSpinning', false)
        // return;
        // pay({
        //   paymentMethod: (this.toPayFor_n === 0 ? 'weixin-payment' : 'alipay-payment'),
        //   orderNumber: this.orderNumber,
        //   userId: this.userId,
        // }).then(res => {
        //   console.log('支付', res);
        //   if (res.code === 1) {
        //     this.aliPayIframe = {};
        //     document.querySelector('.aliPay').innerHTML = '';
        //     if (this.toPayFor_n === 0) {
        //       // 微信支付
        //       this.showModal.isPayQRCode_b = true;
        //       this.$refs.payModal.isPaySucceed(res.data.code_url, res.data.orderNumber, 'kecheng');
        //     } else if (this.toPayFor_n === 1) {
        //       this.aliPayIframe.text = res.data.orderInfoString
        //       // 支付宝支付
        //       this.aliPayIframe.origin = /action\=\"([\w|\W]+json)/.exec(res.data.orderInfoString)[1]
        //       this.$nextTick(() => {
        //         let dataVal = document.querySelector('.aliPay input[name="biz_content"]').value;
        //         this.aliPayIframe.src = this.aliPayIframe.origin + '&biz_content=' + encodeURIComponent(dataVal);
        //       })
        //       this.showModal.isPayQRCode_b = true;
        //       this.$refs.payModal.isPaySucceed('', this.orderNumber, 'kecheng');
        //     }
        //   } else {
        //     message.info(res.msg);
        //     this.$router.push('/pages/coursePlay/coursePlay?courseId=' + this.curriculumId)
        //   }
        //   this.$store.commit('setSpinning', false)
        // })
      },
      // 获取优惠券
      async getUserCouponsByCourse_fn() {
        await getUserCouponsByCourse({
          userId: this.userId,
          status: 'N',
          pageNo: 1,
          pageSize: 1000,
          coursePrice: this.amountPayable - this.convertibilityNum,
          courseId: this.curriculumId,
        }).then(res => {
          console.log('获取优惠券', res);
          if (res.data.code === 1) {
            this.couponList_a = res.data.list;
            // 如果使用完兑换券 金额不为0，那么自动添加优惠券
            if (this.convertibility_o.length && this.convertibility_o.length < this.sectionList.length && this.couponList_a.length) {
              // 默认启用优惠券
              this.couponChecked_b = true;
            }
          }
        })
      },
      // 获取兑换券
      async getUserExchangeVoucherList_fn() {
        await getUserExchangeVoucherList({
          loginUserId: this.userId,
          courseId: this.curriculumId,
          pageNo: 1,
          pageSize: 1000,
        }).then(res => {
          console.log('获取兑换券', res)
          if (res.data.code) {
            if (res.data.list.length) {
              this.convertibility_o = res.data.list;
              this.convertibility_o.map((v, i) => {
                v.let_checked = false;
              })
              // 默认选中兑换券
              this.convertibilityChecked_b = true;
            }
          }
        })
      },
      // 优惠券 计算实付款
      discountNum_fn(item) {
        console.log('优惠券计算', item)
        if(!item || !item.preferentialType){
          this.couponNum = 0;
          this.couponValue = {};
          // 计算实付款
          this.actualPayment_fn();
          return;
        }
        // 判断是否选择了优惠券
        this.couponNum = 0;
        if (this.couponChecked_b) {
          // 计算优惠金额
          if (item.preferentialType === 'MR') {
            // 满减
            if (parseInt(this.amountPayable) >= parseInt(item.threshold)) {
              this.couponNum = item.reductionAmount;
            } else {
              this.couponNum = 0;
            }
          } else if (item.preferentialType === 'DR') {
            // 直减
            this.couponNum = item.reductionAmount;
          }
          // 选中的优惠券对象
          this.couponValue = item;

          // 如果优惠卷已经将该订单免费，那么兑换券去掉选中
          if(this.couponNum >= this.amountPayable){
            this.convertibilityChecked_b = false;
          }
        } else {
          this.couponNum = 0;
          this.couponValue = {};
        }
        // 计算实付款
        this.actualPayment_fn();
      },
      // 兑换券 计算
      async convertibilityNum_fn(items) {
        console.log('兑换券计算******************', items)
        if(!items){
          this.convertibilityNum = 0;
          this.convertibilityValue = [];
          // 计算实付款
          this.actualPayment_fn();
          // 获取优惠券
          this.$nextTick(()=>{
            this.getUserCouponsByCourse_fn()
          })
          return;
        }
        // 初始化
        this.convertibilityNum = 0;
        this.convertibilityValue = [];

        if (this.convertibilityChecked_b) {
          // 进行章节合法验证，并赋值金额
          this.verificationSection();

          this.convertibilityValue = items;

          console.log('需要支付的章节', this.sectionList)
          // 排序，优先贵的章节
          let newSectionList = JSON.parse(JSON.stringify(this.sectionList));
          newSectionList.sort((a, b) => {
            return b.let_price - a.let_price
          })
          // 计算兑换券实际兑换了多少金额
          for (let i = 0, len = items.length; i < len; i++) {
            if (newSectionList[i]) {
              this.convertibilityNum += newSectionList[i].let_price;
            }
          }
          // 如果兑换券已经将该订单免费，那么优惠券去掉选中
          if(this.convertibilityNum >= this.amountPayable){
            this.couponChecked_b = false;
          }
        }else{
          this.convertibilityNum = 0;
          this.convertibilityValue = [];
        }
        // 计算实付款
        this.actualPayment_fn();
        // 因为要获取优惠券列表需要 应付款减兑换券扣除后的金额
        this.$nextTick(()=>{
          this.getUserCouponsByCourse_fn()
        })
      },
      // 验证
      verificationSection() {
        // 进行章节合法验证，并赋值金额
        if (this.courseInfo.payBodyType === 2) {
          this.sectionList.map(v => {
            if (v.type === 2) {
              if (v.courseVideoDiscountPrice) {
                v.let_price = v.courseVideoDiscountPrice;
              } else {
                v.let_price = v.price;
              }
            } else {
              this.$router.push('/pages/coursePlay/coursePlay?courseId=' + this.$route.query.courseId)
            }
          });
        } else {
          this.$router.push('/pages/coursePlay/coursePlay?courseId=' + this.$route.query.courseId)
        }
      },
      // 计算实付款
      actualPayment_fn() {
        console.log('计算实付款-------------')
        this.discountNum = add(this.couponNum , this.convertibilityNum);
        // 计算实付款
        this.actualPayment = (Math.round(this.amountPayable * 1000) - Math.round(this.discountNum * 1000)) / 1000;
        if (this.actualPayment < 0) {
          this.actualPayment = 0;
        }
      },
      // 充值
      recharge_fn() {
        this.showModal.isRecharge = true;
      },
    },
    mounted() {
      this.getUserWallet_fn(); // 获取用户余额
      this.getVideoInfo_fn();   // 获取课程详情
    },
    watch: {
      // 根据优惠券 判断 实付款
      // 'couponChecked_b': {
      //   handler(n, o) {
      //     let maxObj;
      //     if (n) {
      //       // 选择优惠力度大的
      //       maxObj = JSON.parse(JSON.stringify(this.couponList_a)).sort(function (a, b) {
      //         return b.reductionAmount - a.reductionAmount;
      //       })[0];
      //     }
      //     this.discountNum_fn(maxObj)
      //   }
      // },
    }
  }
</script>

<style scoped lang="scss">
  #orderform {
    @extend %safetyWidth;
    background: #fff;
    padding: 6px 200px;
    border-radius: 6px;

    & > h3 {
      font-size: 18px;
      margin: 27px 0;
    }
  }

  /*付款方式*/
  .paymentMethod {
    padding: 20px;

    h3 {
      font-size: 16px;
      margin-bottom: 20px;
    }

    ul {
      display: flex;

      li {
        width: 169px;
        height: 55px;
        line-height: 55px;
        text-align: center;
        border-radius: 6px;
        border: 1px solid #A8A8A8;
        margin-right: 20px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        user-select: none;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;

        /* 选中样式 */
        span {
          position: absolute;
          z-index: 1;
          top: 3px;
          right: 3px;
          color: #fff;
          font-size: 12px;
          display: none;
        }

        img {
          width: 24px;
          margin-right: 0.7rem;
        }

        &.active {
          border-color: $theme_blue;

          &::after {
            content: '';
            width: 46px;
            height: 46px;
            border-radius: 50%;
            background: $theme_blue;
            position: absolute;
            top: -46px;
            right: -46px;
            transform: translate(-50%, 50%);
          }

          span {
            display: block;
          }
        }
      }

      & li:nth-of-type(3) img {
        border-radius: 50%;
      }
    }

    /* 余额 */
    .shengbei {
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
      height: 0;
      opacity: 0;
      visibility: hidden;
      transition-property: height, margin-top, opacity;
      transition-duration: .3s, .3s, 1s;

      .remainingSun {
        font-size: 16px;

        i {
          color: $theme_blue;
          font-size: 16px;
          margin-right: 10px;
        }

        span {
          font-size: 14px;
          color: #888888;
        }
      }

      .sysRecharge {
        font-size: 16px;
        background: $theme_blue;
        height: 32px;
        line-height: 32px;
        width: 72px;
        border-radius: 6px;
        text-align: center;
        color: #fff;
        cursor: pointer;
      }

      &.active {
        opacity: 1;
        margin-top: 22px;
        height: 32px;
        visibility: visible;
      }
    }


  }

  /*付款*/
  .price {
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .amount {
      display: flex;
      flex-direction: column;
      width: 195px;

      span {
        font-size: 16px;
        color: #666666;
        display: flex;
      }

      b {
        font-size: 20px;
        color: #666666;
        font-weight: normal;
        display: flex;

        i {
          color: #F76B03;
        }
      }

      i {
        margin-left: auto;
      }
    }

    .payBtn {
      font-size: 16px;
      color: #fff;
      line-height: 44px;
      padding: 0 30px;
      border-radius: 6px;
      background: $theme_blue;
      height: 44px;
      cursor: pointer;
    }
  }
</style>
